export default __webpack_public_path__ + "static/media/blue2.1b502fff.gif";